import { JSX, useEffect } from "react";
import { useSubscription } from "@apollo/client";
import { AgendaShift, OnCreateAgendaShiftByUserIdSubscription, OnCreateAgendaShiftByUserIdSubscriptionVariables } from "../../../graphql/API";
import { onCreateAgendaShiftByUserId } from "../queries";

const SubscriptionShiftWrapper = ({ userId, onNewShift, subscriptionKey, onError }: {
    userId: string;
    onNewShift: (shift: AgendaShift) => void;
    subscriptionKey: number;
    onError?: () => void;
  }) : JSX.Element | null => {
    // console.log('userId', userId)
    const { data, error } = useSubscription<
      OnCreateAgendaShiftByUserIdSubscription, 
      OnCreateAgendaShiftByUserIdSubscriptionVariables>(onCreateAgendaShiftByUserId, {
        variables: { userId
        // , filter: {
        //   userId: {eq: userId}
        // }},
      },
        skip: !userId,
    });
  
    useEffect(() => {
      if (data?.onCreateAgendaShiftByUserId) {
        onNewShift(data.onCreateAgendaShiftByUserId as AgendaShift);
      }
    }, [data]);
  
    useEffect(() => {
        if (error) {
          console.error("Subscription error");//:", error);
          onError?.();
        }
      }, [error]);
  
    return null;
  };
 export default SubscriptionShiftWrapper  